import dayjs from 'dayjs'

export function initEventsTimeline() {
	const timeline = document.querySelector('div.eventsblock div.timeline')
	if (!timeline || !timeline.dataset.json) {
		return
	}

	// Parse timeline data. (Also turn date strings into native Dates)
	let json = null
	try {
		json = JSON.parse(timeline.dataset.json)
		json.events.forEach(event => event.date = dayjs(event.date))
	}
	catch (error) {
		console.error('Error parsing timeline data.')
		console.error(error)
	}

	if (!json || json.events.length == 0) {
		return
	}

	// Determine the time period.
	const today = dayjs(json.time * 1000)
	const start = json.events[0].date.subtract(1, 'month')
	const end = json.events[json.events.length - 1].date.add(1, 'month')
	const period = end.diff(start, 'month') + 1

	//
	// Create the months.
	for (let a = period; a >= 0; a--) {
		const date = start.add(a, 'month')

		// Element.
		const monthElement = document.createElement('div')
		monthElement.classList.add('month')
		if (date.isBefore(today)) {
			monthElement.classList.add('past')
		}
		timeline.appendChild(monthElement)

		const monthName = document.createElement('span')
		monthName.classList.add('month-name')
		monthName.textContent = new Date(date.format()).toLocaleDateString('en-US', {
			month: 'long',
			year: a == 0 || a == period || date.month() == 0 ? 'numeric' : undefined
		})
		monthElement.appendChild(monthName)

		//
		// Create the events.
		let lastEventDate = 0

		for (let b = (json.events.length - 1); b >= 0; b--) { //const event of json.events) {
			const event = json.events[b]

			if (event.date.year() == date.year() && event.date.month() == date.month()) {
				const eventElement = document.createElement('a')
				eventElement.classList.add('event', event.member && 'member')
				eventElement.href = event.alias
				eventElement.textContent = event.title
				monthElement.appendChild(eventElement)
				if (event.member) {
					eventElement.classList.add('member')
				}

				lastEventDate = event.date.date()
			}
		}

		// Today element.
		if (date.year() == today.year() && date.month() == today.month()) {
			const todayElement = document.createElement('div')
			todayElement.classList.add('today')
			todayElement.textContent = 'Today'
			todayElement.style.bottom = (today.date() / date.daysInMonth() * 100) + '%'
			monthElement.appendChild(todayElement)
		}
	}
}


/*
	const pElements = [...timeline.querySelectorAll('div.months-list p')]
	if (pElements.length == 0) {
		return
	}

	for (const timelineItem of json) {
		const node = makeTimelineItemNode(timelineItem.title, timelineItem.member)
		const position = calculatePosition(timelineItem.date)

		if (position) {
			node.style.top = `${position}px`
			timeline.appendChild(node)
		}
	}

	const todayNode = makeTodayNode()
	todayNode.style.top = `${calculatePosition(new Date())}px`
	timeline.appendChild(todayNode)

	//
	// Helper functions.
	function calculatePosition(date) {
		const itemDate = new Date(date)
		const day = itemDate.getDate()

		const withoutYear = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(itemDate)
		const withYear = new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' }).format(itemDate)

		const target = pElements.find((a) => {
			let innerHTML = a.innerHTML.trim()
			let containsYear = /\d/.test(innerHTML)
			let format = containsYear ? withYear : withoutYear
			return innerHTML == format
		})
		
		const next = pElements[pElements.indexOf(target) - 1]
		if (!next) {
			console.warn('Event was too far in the future to show on timeline. Could be intended behaviour.')
			return undefined
		}

		const difference = target.offsetTop - next.offsetTop
		return (target.offsetTop + ((difference / 32) * day))
	}

	function makeTimelineItemNode(title, isMember) {
		const div = document.createElement('div')
		const p = document.createElement('p')
		
		div.classList.add('timeline-item')
		if (isMember) {
			div.classList.add('member')
		}
		p.innerHTML = title
		div.appendChild(p)

		return div
	}

	function makeTodayNode() {
		const div = document.createElement('div')
		const p = document.createElement('p')

		div.classList.add('today')
		p.innerHTML = 'today'
		div.appendChild(p)

		return div
	}
}
*/